import * as fromDatatype from '../datatype-library';

export interface bl_wf_issue_dashboard_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_dashboard: fromDatatype.GuidDataFieldInterface;
  guid_issue: fromDatatype.GuidDataFieldInterface;
  sort: fromDatatype.IntegerDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_wf_issue_dashboard_link_RowClass implements bl_wf_issue_dashboard_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_dashboard: fromDatatype.GuidDataFieldInterface;
  guid_issue: fromDatatype.GuidDataFieldInterface;
  sort: fromDatatype.IntegerDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
